import { useCallback } from 'react';

import { useModalConfirmationContext } from '../modalConfirmationContext';
import { useSendVerificationEmail } from '../useSendVerificationEmail';

type Props = { showContinueAsGuest: boolean; userId: string; path: string };

export function useInformVerificationEmail(): (props: Props) => Promise<void> {
	const sendVerificationEmail = useSendVerificationEmail();

	const [, { displayModal }] = useModalConfirmationContext();

	return useCallback(
		async ({ showContinueAsGuest, userId, path }) => {
			// not great UX to be sending an email every time the page is loaded/refreshed
			void sendVerificationEmail(path, userId);
			await displayModal({ type: 'emailVerification', path, showContinueAsGuest, userId });
		},
		[sendVerificationEmail, displayModal],
	);
}
